import { render, staticRenderFns } from "./PurchaseOtherPaymentChecklist.vue?vue&type=template&id=1523c5d9"
import script from "./PurchaseOtherPaymentChecklist.vue?vue&type=script&lang=js"
export * from "./PurchaseOtherPaymentChecklist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports